import "rmc-tabs/assets/index.css";
import {
	Rate,
	Slider,
	Menu,
	Dropdown,
	Button,
	Checkbox,
	Input,
	Select,
	Radio,
	Row,
} from "antd";
import { FrownOutlined, SmileOutlined, DownOutlined } from "@ant-design/icons";
import { View, Text } from "react-native-web";
import "antd/dist/antd.css";
import React, { useState } from "react";
import IconSlider from "./IconSlider";
import { Tabs } from "rmc-tabs";
import ToggleButton from "react-toggle-button";

const getRandomColor = () => {
	return (
		"rgb(" +
		(Math.floor(Math.random() * 56) + 120) +
		", " +
		(Math.floor(Math.random() * 56) + 120) +
		", " +
		(Math.floor(Math.random() * 56) + 120) +
		")"
	);
};

class ScrollableTabs extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			questionsArr: this.props.questionsArr,
			selectedTab: this.props.questionsArr[0],
			formSubmit: [],
			ratingValue: 0,
			checkBoxValue: "",
			radioValue: "",
			formComments: "",
			selectedIndex: -1,
			tabIndex: 0,
			selected: false,
			answers: [],
		};
	}

	onOptionSelect(val, index, selectedTab) {
		this.setState({ selectedIndex: index });
		this.onAnswerSelection(index, null, selectedTab);
	}

	setSelection(index) {
		const { answers } = this.state;
		console.log(answers, index);
		if (index > answers.length) {
			this.setState({
				selectedTab: this.props.questionsArr[index],
				ratingValue: 0,
				checkBoxValue: "",
				radioValue: "",
				formComments: "",
				selectedIndex: -1,
				tabIndex: index,
				selected: false,
			});
		} else {
			this.setState({
				selectedTab: this.props.questionsArr[index],
				ratingValue: 0,
				checkBoxValue: "",
				radioValue: "",
				formComments: "",
				selectedIndex: this.state.answers[index]
					? this.state.answers[index].selectedIndex
					: -1,
				tabIndex: index,
				selected: false,
			});
		}
	}

	renderComponent(selectedTab) {
		const { Option } = Select;
		const { TextArea } = Input;
		let questionsDiv = (
			<Text
				style={{
					fontSize: 20,
					fontWeight: "600",
					textAlign: "center",
					minHeight: 50,
					fontFamily: "NunitoSans"
				}}
				adjustsFontSizeToFit
			>
				{selectedTab.title}
			</Text>
		);
		switch (selectedTab.type) {
			case "rating":
				const { ratingValue } = this.state;
				return (
					<View style={{ flex: 1, alignItems: "center" }}>
						{questionsDiv}
						<View style={{ marginVertical: 30 }}>
							<Rate
								allowClear={false}
								style={{ fontSize: 35 }}
								defaultValue={0 || this.state["rating" + selectedTab.tabIndex]}
								value={
									this.state["rating" + selectedTab.tabIndex] || ratingValue
								}
								onChange={(val, event) => {
									this.setState({ ratingValue: val });
									this.onAnswerSelection(val, event, this.state.selectedTab);
								}}
							/>
						</View>
					</View>
				);

			case "dropdown":
				let dropOptionsDiv = [];
				selectedTab.options.forEach(function (value) {
					dropOptionsDiv.push(
						<Option
							value={value}
							style={{
								fontSize: 15,
								fontWeight: "600",
								marginVertical: 20,
							}}
						>
							{value}
						</Option>
					);
				});
				return (
					<View style={{ flex: 1, justifyContent: "center" }}>
						{questionsDiv}
						<View style={{ marginVertical: 30 }}>
							<Select
								placeholder="Select an option"
								style={{ fontSize: 15, fontWeight: "600" }}
								value={this.state["dropdown" + selectedTab.tabIndex]}
								onChange={(val, event) =>
									this.onAnswerSelection(val, event, this.state.selectedTab)
								}
							>
								{dropOptionsDiv}
							</Select>
						</View>
					</View>
				);

			case "options":
				return (
					<View style={{ flex: 1, justifyContent: "center" }}>
						{questionsDiv}
						<View>
							{selectedTab.options.map((item, i) => (
								<Button
									type="Primary"
									style={{
										borderRadius: 20,
										marginTop: 20,
										height: 40,
										width: "100%",
										fontSize: 15,
										fontWeight: "600",
										backgroundColor:
											this.state.selectedIndex == i
												? getRandomColor()
												: "#F7FAFD",
										borderColor:
											this.state.selectedIndex == i ? "#fff" : "#eeeeee",
										color: this.state.selectedIndex == i ? "#fff" : "#000",
									}}
									onClick={() =>
										this.onOptionSelect(item, i, this.state.selectedTab)
									}
								>
									{item}
								</Button>
							))}
						</View>
					</View>
				);

			case "slider":
				return (
					<View style={{ flex: 1, justifyContent: "center" }}>
						{questionsDiv}
						<View style={{ marginVertical: 30 }}>
							<IconSlider
								inputvalue={this.state["sliderval" + selectedTab.tabIndex]}
								min={1}
								max={selectedTab.count}
								onChange={(val, event) =>
									this.onAnswerSelection(val, event, this.state.selectedTab)
								}
							/>
						</View>
					</View>
				);

			case "check":
				let checkDiv = [];
				selectedTab.options.forEach(function (value) {
					checkDiv.push(
						<Row style={{ marginTop: 20 }}>
							<Checkbox
								value={value}
								style={{
									fontSize: 15,
									fontWeight: "600",
									marginVertical: 20,
									textAlign: "center",
								}}
							>
								{value}
							</Checkbox>
						</Row>
					);
				});
				return (
					<View
						style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
					>
						{questionsDiv}
						<View style={{ marginVertical: 30 }}>
							<Checkbox.Group
								// value={
								// 	this.state["checkbox" + selectedTab.tabIndex] ||
								// 	this.state.checkBoxValue
								// }
								onChange={(val, event) =>
									this.onAnswerSelection(val, event, this.state.selectedTab)
								}
							>
								{checkDiv}
							</Checkbox.Group>
						</View>
					</View>
				);

			case "boolean":
				return (
					<View
						style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
					>
						{questionsDiv}
						<View style={{ marginVertical: 30 }}>
							<View style={{ flexDirection: "row" }}>
								<Text
									style={{
										fontSize: 20,
										fontWeight: "600",
										marginHorizontal: 40,
										textAlign: "center",
										fontFamily: "NunitoSans"
									}}
								>
									{this.state.selectedTab.options[0]}
								</Text>
								<ToggleButton
									value={this.state.selected}
									inactiveLabel={""}
									activeLabel={""}
									colors={{
										activeThumb: {
											base: "rgb(250,250,250)",
										},
										inactiveThumb: {
											base: "rgb(62,130,247)",
										},
										active: {
											base: "#25D366",
											hover: "#25D366",
										},
										inactive: {
											base: "rgb(65,66,68)",
											hover: "rgb(95,96,98)",
										},
									}}
									thumbAnimateRange={[-10, 36]}
									thumbStyle={{ height: 30, width: 30, borderRadius: 15 }}
									onToggle={(value) => {
										this.setState({ selected: !this.state.selected }, () => {
											this.onAnswerSelection(
												this.state.selected ? 1 : 0,
												null,
												this.state.selectedTab
											);
										});
									}}
								/>
								<Text
									style={{
										fontSize: 20,
										fontWeight: "600",
										marginHorizontal: 40,
										textAlign: "center",
										fontFamily: "NunitoSans"
									}}
								>
									{this.state.selectedTab.options[1]}
								</Text>
							</View>
						</View>
					</View>
				);

			case "comment":
				return (
					<View
						style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
					>
						<TextArea
							rows={4}
							style={{ width: 300, color: "#000", fontFamily: "NunitoSans" }}
							placeholder="Enter comments"
							onChange={(val, event) => this.props.onComment(val.target.value)}
						/>
					</View>
				);
			default:
				return "";
		}
	}

	render() {
		return (
			<Tabs
				ref={this.props.setRef}
				tabs={this.props.questionsArr}
				onChange={(tab, index) => {
					this.setSelection(index);
					this.props.onChange(this.props.questionsArr[index], index);
				}}
				// renderTabBar={(props) => <DefaultTabBar {...props} page={5}/>}
				tabBarUnderlineStyle={{ borderWidth: 0, borderColor: "white" }}
				tabBarTextStyle={{ color: "white" }}
			>
				<View
					style={{
						flex: 1,
						//paddingTop: 50,
						margin: 20,
					}}
				>
					{this.renderComponent(this.state.selectedTab)}
				</View>
			</Tabs>
		);
	}

	onAnswerSelection(val, event, selectedTab) {
		const { tabIndex, answers } = this.state;

		var answerObj = {
			disabled: true,
			index: this.state.tabIndex,
			skipped: false,
			type: selectedTab.type,
		};

		if (
			selectedTab.type == "options" ||
			selectedTab.type == "boolean" ||
			selectedTab.type == "dropdown"
		) {
			answerObj.selectedIndex = val;
			answerObj.selectedIndex = val;
		} else if (selectedTab.type == "slider" || selectedTab.type == "rating") {
			answerObj.selectedValue = val;
			answerObj.selectedValue = val;
		} else if (selectedTab.type == "check") {
			answerObj.selectedIndex = [];
			val.map((item, index) => {
				answerObj.selectedIndex.push(selectedTab.options.indexOf(item));
			});
		}

		if (answers.length == 0 || tabIndex > answers.length) {
			var currentAnwers = answers.slice();
			currentAnwers.push(answerObj);
			this.setState({ answers: currentAnwers });
		} else {
			var currentAnwer = answers.slice();
			currentAnwer[tabIndex] = answerObj;
			this.setState({ answers: currentAnwer });
		}

		// this.state.formSubmit.push(answerObj);
		this.props.onNextEnable(false);
		this.props.formAnswerObject(selectedTab, answerObj, tabIndex);
	}
}

export default ScrollableTabs;
